// Minimal Standard MIDI File writer — exports a chord progression as .mid
function str(s) {
  return [...s].map((c) => c.charCodeAt(0));
}
function vlq(n) {
  const b = [n & 0x7f];
  n >>= 7;
  while (n) {
    b.unshift((n & 0x7f) | 0x80);
    n >>= 7;
  }
  return b;
}
function u32(n) {
  return [(n >>> 24) & 255, (n >>> 16) & 255, (n >>> 8) & 255, n & 255];
}
function u16(n) {
  return [(n >>> 8) & 255, n & 255];
}

export function progressionToMidiBlob(chordMidiList, bpm = 100, beatsPerChord = 4) {
  const tpb = 480;
  const track = [];
  const mpqn = Math.round(60000000 / bpm);
  track.push(0x00, 0xff, 0x51, 0x03, (mpqn >> 16) & 255, (mpqn >> 8) & 255, mpqn & 255);
  const dur = tpb * beatsPerChord;
  chordMidiList.forEach((notes) => {
    notes.forEach(() => {});
    notes.forEach((n) => track.push(...vlq(0), 0x90, n, 0x64));
    notes.forEach((n, i) => track.push(...vlq(i === 0 ? dur : 0), 0x80, n, 0x40));
  });
  track.push(0x00, 0xff, 0x2f, 0x00);
  const header = [...str("MThd"), ...u32(6), ...u16(0), ...u16(1), ...u16(tpb)];
  const trk = [...str("MTrk"), ...u32(track.length), ...track];
  return new Blob([new Uint8Array([...header, ...trk])], { type: "audio/midi" });
}
